import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <>
      {/* Hero with full-width background image */}
      <section className="relative w-full min-h-[70vh] md:min-h-[80vh] flex items-center justify-center overflow-hidden" data-id="element-112">
        <img src="https://cdn.magicpatterns.com/uploads/5idYWf8xNNcDnsKcj1u8MN/4c3bbe9331169a46c221997450121b53.jpg" alt="Maternidad" className="absolute inset-0 w-full h-full object-cover" data-id="element-113" />
        <div className="absolute inset-0 bg-black/40" data-id="element-114"></div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto flex flex-col items-center" data-id="element-115">
          <h1 className="font-serif text-3xl md:text-5xl lg:text-6xl text-white mb-10 leading-tight uppercase tracking-wide" data-id="element-116">
            Convertirte en mamá no debería sentirse como miedo constante
          </h1>
          <CTAButton href="#compra" data-id="element-117">Acceder a la guía</CTAButton>
        </div>
      </section>

      {/* Product presentation below hero */}
      <section className="w-full bg-white py-20 md:py-28 px-6" data-id="element-118">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center" data-id="element-119">
          <span className="text-warm-500 tracking-[0.3em] uppercase mb-8 text-[32px] font-[700]" data-id="element-120">
            Florecer
          </span>

          <p className="font-serif italic text-lg md:text-xl text-charcoal-400 mb-10 max-w-2xl leading-relaxed" data-id="element-121">
            Una guía creada para acompañarte en el inicio de tu maternidad desde
            un lugar real, simple y sin exigencias
          </p>

          <a href="https://checkout.aulamater.online/cart/44073141076067:1" className="block w-full max-w-xs mx-auto mb-12 transition-opacity duration-500 hover:opacity-90" data-id="element-122">
            <img src="https://cdn.magicpatterns.com/uploads/aS8TEinEsRuS6MDLyNf5B7/349bf724-620e-463d-a804-95c66235b1b4.png" alt="Florecer Ebook" className="w-full h-auto" data-id="element-123" />
          </a>

          <p className="font-serif text-xl md:text-2xl text-charcoal-600 mb-10 max-w-2xl leading-relaxed" data-id="element-124">
            Una guía para acompañarte en este momento tan importante, entender a
            tu bebé y empezar a confiar en vos desde el primer día.
          </p>

          <div className="space-y-4 text-charcoal-400 text-lg font-light mb-16 max-w-2xl leading-relaxed" data-id="element-125">
            <p data-id="element-126">Ser mamá no siempre se siente como lo imaginabas.</p>
            <p data-id="element-127">
              A veces aparecen dudas, cansancio… y la sensación de no saber si
              lo estás haciendo bien.
            </p>
            <p data-id="element-128">Y aunque todos opinan… nadie te explica realmente qué hacer.</p>
          </div>

          <div className="flex flex-col items-center gap-4" data-id="element-129">
            <CTAButton href="#compra" data-id="element-130">Acceder a la guía</CTAButton>
            <p className="text-charcoal-300 text-sm tracking-wider uppercase mt-2" data-id="element-131">
              $19.990 ARS · Acceso inmediato
            </p>
          </div>
        </div>
      </section>
    </>;
}